import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { MonitoringTab } from "../components/monitoring/MonitoringTab";
import { useAuth } from "../contexts/AuthContext";

/** Pagina «Monitoraggio»: solo guardia di ruolo e layout, la logica e' in MonitoringTab. */
export default function Monitoring() {
	const { user } = useAuth();
	const isAdmin = user?.is_admin || user?.role === "admin";
	const isCoach = user?.role === "coach" || isAdmin;

	if (!isCoach) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout>
			<MonitoringTab />
		</Layout>
	);
}
